export const NavItem = [
  {
    id: 1,
    title: ' About us',
    link: '/about-us',
    m_link: '/about-us',
    arr: [],
  },
  {
    id: 2,
    title: 'Product',
    link: '/product',
    m_link: '#/',
    arr: [
      { id: 1, title: 'EG-Platform', link: '/product/EG-Platform' },
      { id: 2, title: 'SentinelONE', link: '/product/SentinelONE' },
      { id: 3, title: 'BaroPAM', link: '/product/BaroPAM' },
    ],
  },
  {
    id: 3,
    title: 'Download',
    link: '/downLoad',
    m_link: '/downLoad',
    arr: [],
  },
  {
    id: 4,
    title: 'contact us',
    link: '/contact-us',
    m_link: '#/',
    arr: [
      { id: 1, title: '제품문의', link: '/contact-us/product' },
      { id: 2, title: '제휴문의', link: '/contact-us/partner' },
    ],
  },
];
